import { Link as MuiLink } from '@mui/material';
import type { FC } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import type { LinkProps } from './Link.types';
import { isExternalLink } from './LinkUtils';

export const Link: FC<LinkProps> = ({ to, children, ...props }) => {
  // If the link is external, we can use the MUI Link component with the href prop
  if (isExternalLink(to)) {
    return (
      <MuiLink href={to} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </MuiLink>
    );
  }

  // If the link is not external, we can assume it is internal and use the React Router Link component
  return (
    <MuiLink component={ReactRouterLink} to={to} {...props}>
      {children}
    </MuiLink>
  );
};
